import React from 'react';
import WallForm from './form';
import {getWallCouponsItem, updateWallCouponsItem} from '../../modules/Api';
import {notification} from 'antd';
import history from '../../modules/History';

class EditWall extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchStoreDetail();
    }
    fetchStoreDetail() {
        const wall_id = this.props.match.params.id;
        getWallCouponsItem(wall_id, data => {this.setState({data: data})});
    }
    submit(formData) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const wall_id = this.props.match.params.id;
        updateWallCouponsItem(wall_id, formData, () => {
            notification.open({
                message: `دیوار ویرایش شد!`,
            });
            this.setState({submitted: false});
            history.item.push(`/wall`);
        })
    }
    render() {
        return (<div><WallForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditWall;


// WEBPACK FOOTER //
// ./src/containers/Wall/edit.js